import { isValidPositiveValue } from '@buildersbank/validations';
import { FormValidator } from '~/modules';

export const validationSchema = FormValidator.object().shape({
  creditSimulationValue: FormValidator.string()
    .required('Campo obrigatório')
    .test(
      'creditSimulationValue',
      'O valor deve ser um número',
      isValidPositiveValue,
    ),
});

export type CreditSimulationValueFormValues = Record<
  'creditSimulationValue',
  string
>;

export const initialValues: CreditSimulationValueFormValues = {
  creditSimulationValue: '',
};
